import { render } from "./clientes.vue?vue&type=template&id=cb3ecee4&scoped=true"
import script from "./clientes.vue?vue&type=script&lang=js"
export * from "./clientes.vue?vue&type=script&lang=js"

import "./clientes.vue?vue&type=style&index=0&id=cb3ecee4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\yordis.escorcia\\Downloads\\relojito\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb3ecee4"]])

export default __exports__